export default __webpack_public_path__ + "static/media/mp3.b4b98648.svg";